import { render, staticRenderFns } from "./KnowYourTyres.vue?vue&type=template&id=663893f4&"
import script from "./KnowYourTyres.vue?vue&type=script&lang=js&"
export * from "./KnowYourTyres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports